import React, { FC } from 'react';
import { FilterOptions } from '../../reducers/filters.types';

type BedsOptions = {
    options: FilterOptions;
    bedsOtherInt: number;
    keyPrefix: string;
};

export const SelectBedsMinOptions: FC<BedsOptions> = ({
    options,
    bedsOtherInt,
    keyPrefix
}) => {
    const bedsMaxInt = bedsOtherInt;

    return (
        <>
            {options
                ?.filter(
                    (bedMinOption) =>
                        isNaN(bedsMaxInt) ||
                        bedMinOption.value === '' ||
                        bedsMaxInt >= parseInt(bedMinOption.value)
                )
                ?.map((bedMinOption) => {
                    if (!bedMinOption) {
                        return null;
                    }
                    const { value, label } = bedMinOption;
                    const key = `${keyPrefix}-${value}`;

                    return (
                        <option key={key} value={value}>
                            {label}
                        </option>
                    );
                })}
        </>
    );
};

export const SelectBedsMaxOptions: FC<BedsOptions> = ({
    options,
    bedsOtherInt,
    keyPrefix
}) => {
    const bedsMinInt = bedsOtherInt;

    return (
        <>
            {options
                ?.filter(
                    (bedMaxOption) =>
                        isNaN(bedsMinInt) ||
                        bedMaxOption.value === '' ||
                        bedsMinInt <= parseInt(bedMaxOption.value)
                )
                ?.map((bedMaxOption) => {
                    if (!bedMaxOption) {
                        return null;
                    }
                    const { value, label } = bedMaxOption;
                    const key = `${keyPrefix}-${value}`;

                    return (
                        <option key={key} value={value}>
                            {label}
                        </option>
                    );
                })}
        </>
    );
};
